import React from 'react';
import "../App.css";
import BackToHomePage from "./BackToHomePage";
import Home from './Home';
import Snow from './Snow';

class About extends Home{

        constructor(props){
            super(props);
        }

        render(){
            return(
                <main>

                    <div className={this.state.scale}>

                        <Snow></Snow>

                        <div id="title" className=
                            "text-white text-center text-3xl md:text-5xl mt-5">
                            <h1 className="p-7 font-black">About Me</h1>
                        </div>

                        <div
                        className="mx-5 md:mx-32 text-white text-1xl md:text-4xl p-5 text-mono my-10">
                            <article className="text-center">
                                I'm Marjanov Milan. I'm 23 year old data science student at faculty of technical
                                sciences, Novi Sad, Serbia.
                    
                                I'm passionate about desinging web sites and front end developing.
            
                                I'm interested in developing interactive web sites with unique
                                styles and animations. I dont like stereotypes and monotony. I'm a big React lover.

                                No work experience, except some freelance projects.

                                Currently at last year of education, so looking forward to internship and job. 
                            </article>
                        </div>
            
                        <BackToHomePage>
                        </BackToHomePage>

                    </div>

                </main>
            )
        }
}

export default About;